module.exports = __webpack_public_path__ + "img/img01.d268471a.png";